module.exports = __webpack_public_path__ + "img/Dantam Hair 58.927ad6f2.jpg";